module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-grid"
  }, [_c('div', {
    staticClass: "p-col"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-rounded",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "icon": "pi pi-plus"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openBasic.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '50vw'
    }),
    attrs: {
      "header": "Unit Conversion",
      "modal": true,
      "contentStyle": {
        'overflow': 'visible'
      },
      "visible": _vm.displayBasic,
      "closable": false
    },
    on: {
      "update:visible": function($event) {
        _vm.displayBasic = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button-raised p-button-rounded",
          attrs: {
            "label": _vm.editing ? 'Update' : 'Add'
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addUnitConversion.apply(null, arguments)
            }
          }
        }), _vm._v(" "), (!_vm.editing) ? _c('Button', {
          staticClass: "p-button-raised p-button-info",
          attrs: {
            "label": "Add & New"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addAndNewUnitConversion.apply(null, arguments)
            }
          }
        }) : _vm._e(), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.cancel.apply(null, arguments)
            }
          }
        })]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Name"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "name"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "unitFrom"
    }
  }, [_vm._v("Unit From")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.measurementUnitList,
      "id": "unitFrom",
      "optionLabel": "shortName",
      "filter": true,
      "placeholder": "Select Unit",
      "showClear": true
    },
    model: {
      value: (_vm.unitFrom),
      callback: function($$v) {
        _vm.unitFrom = $$v
      },
      expression: "unitFrom"
    }
  })], 1), _vm._v(" "), _c('MeasurementUnit', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Add Unit'),
      expression: "'Add Unit'",
      modifiers: {
        "top": true
      }
    }],
    staticStyle: {
      "margin-top": "1.3em"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "unitFrom"
    }
  }, [_vm._v("Unit To")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.measurementUnitList,
      "id": "unitTo",
      "optionLabel": "shortName",
      "filter": true,
      "placeholder": "Select Unit",
      "showClear": true
    },
    model: {
      value: (_vm.unitTo),
      callback: function($$v) {
        _vm.unitTo = $$v
      },
      expression: "unitTo"
    }
  })], 1), _vm._v(" "), _c('MeasurementUnit', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Add Unit'),
      expression: "'Add Unit'",
      modifiers: {
        "top": true
      }
    }],
    staticStyle: {
      "margin-top": "1.3em"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "unitValue1"
    }
  }, [_vm._v("Unit Value")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "unitValue1"
    },
    model: {
      value: (_vm.unitFromValue),
      callback: function($$v) {
        _vm.unitFromValue = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "unitFromValue"
    }
  })], 1), _vm._v(" "), _c('label'), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-3"
  }, [_c('label', {
    attrs: {
      "for": "unitValue2"
    }
  }, [_vm._v("Unit Value")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "unitValue2"
    },
    model: {
      value: (_vm.unitToValue),
      callback: function($$v) {
        _vm.unitToValue = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "unitToValue"
    }
  })], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-110e3856"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/itemDialog/UnitConversionDialog.vue
// module id = 2047
// module chunks = 0